import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../store'

export type WarningType = 'offline' | 'busy' | 'weak_connection' | 'low_battery'

export interface TerminalStatusState {
  /** Current Loading state for terminal status */
  isLoading: boolean | null
  /** Current warning type, or null if no warning */
  warningType: WarningType | null
  /** Whether to continue with payment despite terminal warning */
  attemptPayment: boolean
  /** Counter to trigger manual refreshes - increment to request a refresh */
  refreshTrigger: number
}

const initialState: TerminalStatusState = {
  warningType: null,
  isLoading: null,
  attemptPayment: false,
  refreshTrigger: 0,
}

const terminalStatusSlice = createSlice({
  name: 'terminalStatus',
  initialState,
  reducers: {
    setTerminalStatusLoadingState: (
      state,
      action: PayloadAction<boolean | null>
    ) => {
      state.isLoading = action.payload
    },
    setTerminalStatusWarningType: (
      state,
      action: PayloadAction<WarningType | null>
    ) => {
      state.warningType = action.payload
    },
    setAttemptPayment(state, action: PayloadAction<boolean>) {
      state.attemptPayment = action.payload
    },
    requestTerminalStatusUpdate(state) {
      state.refreshTrigger += 1
    },
  },
})

export const {
  setTerminalStatusLoadingState,
  setTerminalStatusWarningType,
  setAttemptPayment,
  requestTerminalStatusUpdate,
} = terminalStatusSlice.actions

// Selectors
export const selectTerminalStatusLoadingState = (state: RootState) =>
  state.terminalStatus.isLoading

export const selectTerminalStatusWarningType = (state: RootState) =>
  state.terminalStatus.warningType

export const selectAttemptPayment = (state: RootState) =>
  state.terminalStatus.attemptPayment

export const selectTerminalStatusRefreshTrigger = (state: RootState) =>
  state.terminalStatus.refreshTrigger

export const reducer = terminalStatusSlice.reducer
